export const getFileExt = (name: string) => {
  if (!name.includes('.')) {
    return ''
  }

  return name.substring(name.lastIndexOf('.'), name.length)
}
